export const playerInitials = (player) => {
  const first = player?.first_name?.trim()?.[0] || "";
  const last = player?.last_name?.trim()?.[0] || "";
  return (first + last).toUpperCase() || "?";
};

export const toDateInputValue = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toISOString().slice(0, 10);
};

export const medicalRecordFileName = (url) => {
  if (!url) return "";
  try {
    const pathname = new URL(url).pathname;
    return decodeURIComponent(pathname.split("/").pop() || "");
  } catch {
    return url.split("/").pop() || "";
  }
};
